import { render } from "./RequireNewPassword.vue?vue&type=template&id=ad9c2302"
import script from "./RequireNewPassword.vue?vue&type=script&lang=js"
export * from "./RequireNewPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__